import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: lightsteelblue;
  display: flex;
  flex-direction: column; /* Ensure vertical stacking */
  align-items: center;
  justify-content: flex-start; /* Start from the top */
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
  z-index: 999;
  overflow-y: hidden; /* Prevent the entire sidebar from scrolling */
`;

export const CloseIcon = styled(FaTimes)`
  color: #000;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  border: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`;

export const SidebarWrapper = styled.div`
  width: 100%;
  max-height: 100vh; /* Prevent exceeding viewport height */
  overflow-y: auto; /* Allow content to scroll */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align items from the top */
  padding: 20px;
  box-sizing: border-box;
`;

export const SidebarHeading = styled.h1`
    text-align: center;
    color: #000;
`;

export const SidebarMenu = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 40px);
  }
`;

export const SidebarLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #000;
  cursor: pointer;

  &:hover {
    color: #fff;
    transition: 0.2s ease-in-out;
  }
`;

export const SideBtnWrap = styled.div`
  display: flex;
  flex-direction: column; /* Stack buttons vertically */
  align-items: center;
  justify-content: flex-start; /* Ensure components start from the top */
  width: 100%;
  padding: 10px 0;
  gap: 10px; /* Adds spacing between buttons */
  overflow-y: auto; /* Enable scrolling if the content exceeds available space */
  max-height: calc(100vh - 80px); /* Ensure the buttons don’t overflow the viewport */
`;

export const SidebarRoute = styled(LinkR)`
  border-radius: 50px;
  background: #fff;
  white-space: nowrap;
  padding: 16px 64px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #fff;
  }
`;
